if (!customElements.get('quantity-input')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = null;
      this.plusButton = null;
      this.minusButton = null;
    }

    connectedCallback() {
      this.input = this.querySelector('input');
      this.plusButton = this.querySelector('[data-increment]');
      this.minusButton = this.querySelector('[data-decrement]');

      if (!this.input || !this.plusButton || !this.minusButton) return;

      this.plusButton.addEventListener('click', this.increase.bind(this));
      this.minusButton.addEventListener('click', this.decrease.bind(this));
    }

    increase() {
      const step = Number(this.input.step) || 1;
      const max = Number(this.input.max || Infinity);
      let value = Number(this.input.value);

      if (isNaN(value)) value = 0;
      value = Math.min(value + step, max);

      this.input.value = value;
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    decrease() {
      const step = Number(this.input.step) || 1;
      const min = Number(this.input.min || 0);
      let value = Number(this.input.value);

      if (isNaN(value)) value = 0;
      value = Math.max(value - step, min);
      this.input.value = value;
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  customElements.define('quantity-input', QuantityInput);
}
